import { Address } from 'cluster';
import * as FormTypes from '../forms/types';
import {
    BuildRentType,
    CertificateOfOccupancyType,
    ExitType,
    LoanType,
    PreferredTermType,
    PropertyDevelopmentType,
} from '@apply/constants';
import { IAddress } from '../cross';

const prefix = 'property/';

export const RESET = `${prefix}RESET`;
export const ADD_PROPERTY = `${prefix}ADD_PROPERTY`;
export const REMOVE_PROPERTY = `${prefix}REMOVE_PROPERTY`;
export const UPDATE_STRUCTURE_TYPE = `${prefix}UPDATE_STRUCTURE_TYPE`;
export const UPDATE_ADDRESS_LINE1 = `${prefix}UPDATE_ADDRESS_LINE1`;
export const UPDATE_ADDRESS_LINE2 = `${prefix}UPDATE_ADDRESS_LINE2`;
export const UPDATE_ADDRESS_CITY = `${prefix}UPDATE_ADDRESS_CITY`;
export const UPDATE_ADDRESS_STATE = `${prefix}UPDATE_ADDRESS_STATE`;
export const UPDATE_ADDRESS_COUNTY = `${prefix}UPDATE_ADDRESS_COUNTY`;
export const UPDATE_ADDRESS_ZIPCODE = `${prefix}UPDATE_ADDRESS_ZIPCODE`;

// non-rental-specific
export const UPDATE_LEGAL_DESCRIPTION = `${prefix}UPDATE_LEGAL_DESCRIPTION`;
export const UPDATE_BUDGET = `${prefix}UPDATE_BUDGET`;
export const UPDATE_LAND_BUDGET = `${prefix}UPDATE_LAND_BUDGET`;
export const UPDATE_FIXFLIP_BUDGET = `${prefix}UPDATE_FIXFLIP_BUDGET`;
export const UPDATE_PLANS = `${prefix}UPDATE_PLANS`;
export const UPDATE_SPEC_SHEET = `${prefix}UPDATE_SPEC_SHEET`;
export const UPDATE_SURVEY = `${prefix}UPDATE_SURVEY`;
export const UPDATE_PRESOLD = `${prefix}UPDATE_PRESOLD`;
export const UPDATE_CONSTRUCTION_STARTED = `${prefix}UPDATE_CONSTRUCTION_STARTED`;
export const UPDATE_IS_ACQUISITION_FINANCING = `${prefix}UPDATE_IS_ACQUISITION_FINANCING`;
export const UPDATE_ANY_EXISTING_DEBT = `${prefix}UPDATE_ANY_EXISTING_DEBT`;
export const UPDATE_PRESALE_CONTRACT = `${prefix}UPDATE_PRESALE_CONTRACT`;
export const UPDATE_LAND_SIZE = `${prefix}UPDATE_LAND_SIZE`;
export const UPDATE_CONTACT_IS_PRIMARY = `${prefix}UPDATE_CONTACT_IS_PRIMARY`;
export const UPDATE_NON_RENTAL_NAME = `${prefix}UPDATE_NON_RENTAL_NAME`;
export const UPDATE_NON_RENTAL_EMAIL = `${prefix}UPDATE_NON_RENTAL_EMAIL`;
export const UPDATE_NON_RENTAL_PHONE = `${prefix}UPDATE_NON_RENTAL_PHONE`;
export const UPDATE_GENERAL_CONTRATOR_RESUME = `${prefix}UPDATE_GENERAL_CONTRATOR_RESUME`;
export const UPDATE_GENERAL_CONTRATOR_WILL_WORK = `${prefix}UPDATE_GENERAL_CONTRATOR_WILL_WORK`;
export const UPDATE_GENERAL_CONTRATOR_NAME = `${prefix}UPDATE_GENERAL_CONTRATOR_NAME`;

// non-rental-specific (fix-flop)
export const UPDATE_UPDATE_YEAR_BUILT = `${prefix}UPDATE_UPDATE_YEAR_BUILT`;
export const UPDATE_UPDATE_BUILD_TYPE = `${prefix}UPDATE_UPDATE_BUILD_TYPE`;
export const UPDATE_UNDERGROUND_STORAGE_TANKS = `${prefix}UPDATE_UNDERGROUND_STORAGE_TANKS`;
export const UPDATE_ACQUISITIONS_DATE = `${prefix}UPDATE_ACQUISITIONS_DATE`;
export const UPDATE_IS_FORECLOSURE = `${prefix}UPDATE_IS_FORECLOSURE`;
export const UPDATE_NEED_FUNDING_AT_PURCHASE = `${prefix}UPDATE_NEED_FUNDING_AT_PURCHASE`;
export const UPDATE_INTENDED_WORK = `${prefix}UPDATE_INTENDED_WORK`;
export const UPDATE_EXPECTED_LISTING_PRICE = `${prefix}UPDATE_EXPECTED_LISTING_PRICE`;
export const UPDATE_TARGET_LOAN_REQUEST = `${prefix}UPDATE_TARGET_LOAN_REQUEST`;

// non-rental-specific (land)
export const UPDATE_CURRENT_PLATTED_LOTS = `${prefix}UPDATE_CURRENT_PLATTED_LOTS`;
export const UPDATE_PLANNED_PLATTED_LOTS = `${prefix}UPDATE_PLANNED_PLATTED_LOTS`;
export const UPDATE_REQUIRED_ZONING_OR_ENTITLEMENT = `${prefix}UPDATE_REQUIRED_ZONING_OR_ENTITLEMENT`;
export const UPDATE_DESCRIBE_REQUIRED_INPSECTIONS = `${prefix}UPDATE_DESCRIBE_REQUIRED_INPSECTIONS`;
export const UPDATE_WILL_BUILD_ON_LAND_YOURSELF = `${prefix}UPDATE_WILL_BUILD_ON_LAND_YOURSELF`;
export const UPDATE_EXIT_PLANS = `${prefix}UPDATE_EXIT_PLANS`;
export const UPDATE_STARTED_SITE_WORK = `${prefix}UPDATE_STARTED_SITE_WORK`;
export const UPDATE_NONRENTAL_CURRENT_DEBT = `${prefix}UPDATE_NONRENTAL_CURRENT_DEBT`;

// rental specific
export const UPDATE_UNIT_NUMBER = `${prefix}UPDATE_UNIT_NUMBER`;
export const UPDATE_PURCHASED_LESS_THAN_TWO_YEAR_AGO = `${prefix}UPDATE_PURCHASED_LESS_THAN_TWO_YEAR_AGO`;
export const UPDATE_MORE_THAN_TENK_EXPENDITURES = `${prefix}UPDATE_MORE_THAN_TENK_EXPENDITURES`;
export const UPDATE_CURRENT_DEBT = `${prefix}UPDATE_CURRENT_DEBT`;
export const UPDATE_NUMBER_RENTAL_UNITS = `${prefix}UPDATE_NUMBER_RENTAL_UNITS`;
export const UPDATE_NUMBER_CONSTRUCTION_UNITS = `${prefix}UPDATE_NUMBER_CONSTRUCTION_UNITS`;
export const UPDATE_NUMBER_UNITS_INCOME_RESTRICTED = `${prefix}UPDATE_NUMBER_UNITS_INCOME_RESTRICTED`;
export const UPDATE_RENTAL_BUILD_TYPE = `${prefix}UPDATE_RENTAL_BUILD_TYPE`;
export const UPDATE_RENTAL_BUILDRENT_TYPE = `${prefix}UPDATE_RENTAL_BUILDRENT_TYPE`;
export const UPDATE_RENTAL_TARGET_LOAN_REQUEST = `${prefix}UPDATE_RENTAL_TARGET_LOAN_REQUEST`;
export const UPDATE_RENTAL_NUMBER_UNITS_INCOME_RESTRICTED = `${prefix}UPDATE_RENTAL_NUMBER_UNITS_INCOME_RESTRICTED`;
export const UPDATE_PREFERRED_TERM_REQUEST = `${prefix}UPDATE_PREFERRED_TERM_REQUEST`;
export const UPDATE_RENTAL_YEAR_BUILT = `${prefix}UPDATE_RENTAL_YEAR_BUILT`;
export const UPDATE_RENTAL_IS_ACQUISITION_FINANCING = `${prefix}UPDATE_RENTAL_IS_ACQUISITION_FINANCING`;
export const UPDATE_PURCHASE_DATE = `${prefix}UPDATE_PURCHASE_DATE`;
export const UPDATE_RENTAL_IS_LOAN_PROCEEDS_USED_PROPERTY_IMPROVEMENTS = `${prefix}UPDATE_RENTAL_IS_LOAN_PROCEEDS_USED_PROPERTY_IMPROVEMENTS`;

export const UPDATE_PURCHASE_CONTRACT = `${prefix}UPDATE_PURCHASE_CONTRACT`;
export const UPDATE_CAPITAL_EXPENDITURES = `${prefix}UPDATE_CAPITAL_EXPENDITURES`;
export const UPDATE_RENTAL_UNIT = `${prefix}UPDATE_RENTAL_UNIT`;
export const UPDATE_PROVIDE_RENTAL_UNITS_LATER = `${prefix}UPDATE_PROVIDE_RENTAL_UNITS_LATER`;
export const REPLACE_PROPERTIES_STATE = `${prefix}REPLACE_PROPERTIES_STATE`;
export const UPDATE_IS_DIRTY = `${prefix}UPDATE_IS_DIRTY`;
export const UPDATE_CURRENT_PROPERTY_ID = `${prefix}UPDATE_CURRENT_PROPERTY_ID`;

export const SAVE_FORM = `${prefix}SAVE_FORM`;

export const nonRentalStructureTypes = ['Detached House', 'Townhouse', 'Duplex', 'Triplex', 'Quadplex', '5+ Unit'] as const;
export type NonRentalStructureType = (typeof nonRentalStructureTypes)[number];

export const rentalStructureTypes = [
    'Detached House',
    'Townhouse',
    'Duplex',
    'Triplex',
    'Quadplex',
    '5+ Unit',
    'Single Condo Unit Within Larger Structure',
] as const;
export type RentalStructureType = (typeof rentalStructureTypes)[number];

export type AttachmentType =
    | 'budget'
    | 'plans'
    | 'spec sheet'
    | 'capital expenditures'
    | 'presale contract'
    | 'purchase contract'
    | 'general contractor resume'
    | 'survey'
    | 'management agreement';

export const attachmentsSupportingOnlineForm: AttachmentType[] = ['budget', 'spec sheet'];
export const attachmentsSupportingTextData: AttachmentType[] = ['general contractor resume'];

export type AttachmentHandleMode =
    | 'createnewform'
    | 'editsavedform'
    | 'uploadfile'
    | 'providelater'
    | 'willnotprovide'
    | 'unset'
    | 'textdata';

export type Attachment = {
    handleMode: AttachmentHandleMode;

    uploadedFilename?: string;
    uploadedFileApiId?: string;
    fileType?: string;
    formId?: string;
    formStorage?: 'shared' | 'inline';
    data?: string;
};

export const attachmentInitialState: Attachment = { handleMode: 'unset' };

export const LandSizeUnit = ['Acres', 'Square Feet'] as const;
export type LandSizeUnitType = (typeof LandSizeUnit)[number];

export type LandSize = {
    quantity: string;
    unit: LandSizeUnitType;
};

export const landSizeInitialState: LandSize = {
    quantity: '',
    unit: 'Square Feet',
};

export const propertyAddressInitialState: IAddress = {
    street1: '',
    street2: '',
    city: '',
    state: '',
    county: '',
    zipCode: '',
};

export type NonRental = {
    legalDescription?: string;
    budget?: Attachment;
    landBudget?: Attachment;
    fixFlipBudget?: Attachment;
    plans?: Attachment;
    specSheet?: Attachment;
    survey?: Attachment;
    preSold?: boolean;
    contactIsPrimary?: boolean;
    presaleContract?: Attachment;
    constructionStarted?: boolean;
    isAquisitionFinancing?: boolean;
    anyExistingDebt?: boolean;
    landSize?: LandSize;
    email?: string;
    name?: string;
    phone?: string;
    generalContractorWillWork?: boolean;
    generalContractorName?: string;
    generalContractorResume?: Attachment;
    numberUnits?: number;
    unitsIncomeRestricted?: number;
    yearBuilt?: number;
    buildType?: number;
    undergroundStorageTanks?: boolean;
    acquisitionDate?: string;
    isForeclosure?: boolean;
    needFundingAtPurchase?: boolean;
    intendedWork?: string;
    expectedListingPrice?: number;
    targetLoanRequest?: number;
    currentPlattedLots?: number;
    plannedPlattedLots?: number;
    requiredZoningOrEntitlement?: boolean;
    describeRequiredInspections?: string;
    willBuildOnLandYourself?: boolean;
    exitPlans?: string;
    startedSiteWork?: boolean;
    currentDebt?: number;
    propertyDevelopmentType?: PropertyDevelopmentType;
    propertyDevelopmentOther?: string;
    ownedThroughoutDevelopment?: boolean;
    certificateOfOccupancy?: CertificateOfOccupancyType;
    proofOfOccupancy?: Attachment;
    workNeeded?: boolean;
    workNeededDescription?: string;
    hoaDues?: boolean;
    preferredTermType?: PreferredTermType;
    exitType?: ExitType;
    expectedTakeOutLoanAmount?: number;
};

const currentDate = () => {
    const date = new Date();
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
};

export const nonRentalInitialState: NonRental = {
    legalDescription: '',
    budget: { ...attachmentInitialState },
    landBudget: { ...attachmentInitialState },
    fixFlipBudget: { ...attachmentInitialState },
    plans: { ...attachmentInitialState },
    specSheet: { ...attachmentInitialState },
    survey: { ...attachmentInitialState },
    presaleContract: { ...attachmentInitialState },
    preSold: undefined,
    contactIsPrimary: undefined,
    email: '',
    name: '',
    phone: '',
    constructionStarted: undefined,
    isAquisitionFinancing: undefined,
    anyExistingDebt: undefined,
    landSize: { ...landSizeInitialState },
    generalContractorWillWork: undefined,
    generalContractorName: '',
    generalContractorResume: { ...attachmentInitialState },
    acquisitionDate: null,
};

export type RentalUnit = {
    guid: string;
    occupied?: boolean;
    rent?: number;
    squareFeet?: number;
    bedrooms?: number;
    bathrooms?: number;
    garageBays?: number;
};

export const rentalUnitInitialState: RentalUnit = {
    guid: undefined,
    occupied: undefined,
    rent: undefined,
    squareFeet: undefined,
    bedrooms: undefined,
    bathrooms: undefined,
    garageBays: undefined,
};

export type Rental = {
    unitNumber?: string;
    purchasedLessThan2YearsAgo?: boolean;
    purchaseContract?: Attachment;
    moreThan10kExpenditures?: boolean;
    capitalExpenditures?: Attachment;
    currentDebt?: number;
    numberRentalUnits?: number;
    provideRentalUnitsLater?: boolean;
    buildType?: number;
    targetLoanRequest?: number;
    preferredTermType?: number;
    unitsIncomeRestricted?: number;
    yearBuilt?: number;
    isAquisitionFinancing?: boolean;
    purchaseDate?: string;
    isLoanProceedsUsedPropertyImprovements?: boolean;
    buildRentTypeId?: BuildRentType | undefined;
    buildWorkDescriptionTypeId?: number | undefined;
};

export const rentalInitialState: Rental = {
    unitNumber: undefined,
    purchasedLessThan2YearsAgo: undefined,
    purchaseContract: { ...attachmentInitialState },
    moreThan10kExpenditures: undefined,
    capitalExpenditures: { ...attachmentInitialState },
    currentDebt: undefined,
    numberRentalUnits: undefined,
    provideRentalUnitsLater: false,
};

export type Property = {
    guid: string;
    structureType?: NonRentalStructureType | RentalStructureType;
    address?: IAddress;
    nonRental?: NonRental;
    rental?: Rental;
    rentalUnits: RentalUnit[];
    buildRentTypeId?: BuildRentType | undefined;
};

export const propertyInitialState: Property = {
    guid: '',
    structureType: undefined,
    address: { ...propertyAddressInitialState },
    nonRental: nonRentalInitialState,
    rental: rentalInitialState,
    rentalUnits: [],
};

export type PropertiesState = {
    isDirty?: boolean;
    currentPropertyId?: string;
    items: Property[];
    forms: FormTypes.FormState[];
};

export const propertiesInitialState: PropertiesState = {
    isDirty: false,
    currentPropertyId: undefined,
    items: [],
    forms: [],
};

export const isAttachment = (toCheck: unknown): toCheck is Attachment => (toCheck as Attachment).handleMode !== undefined;

export const isLandSize = (toCheck: unknown): toCheck is LandSize => (toCheck as LandSize).unit !== undefined;

export const formatPropertyName = (index: number, property: Property) => {
    if (!property) {
        return '';
    }

    const start = `(${index + 1}) ${property?.address?.street1}`;
    if (property?.address?.street2) {
        return `${start}; ${property?.address?.street2}`;
    } else {
        return start;
    }
};

export const constructReviewFormsAdvisoryMessagePrefix = (loanType: LoanType, property: Property): string => {
    const formsRequired = [];
    if ([LoanType.Construction, LoanType.BuildRent, LoanType.Model].includes(loanType)) {
        if (property?.nonRental?.budget?.handleMode === 'providelater') {
            formsRequired.push('Budget');
        }
        if (property?.nonRental?.plans?.handleMode === 'providelater') {
            formsRequired.push('Plans');
        }
        if (property?.nonRental?.specSheet?.handleMode === 'providelater') {
            formsRequired.push('Spec Sheet');
        }
        if (property?.nonRental?.survey?.handleMode === 'providelater') {
            formsRequired.push('Survey');
        }
        if (property?.nonRental?.presaleContract?.handleMode === 'providelater') {
            formsRequired.push('Presale Contract');
        }
        if (
            property?.nonRental?.generalContractorResume?.handleMode === 'providelater' &&
            property?.nonRental?.generalContractorWillWork
        ) {
            formsRequired.push('G.C. Resume');
        }
    }

    if ([LoanType.Rental, LoanType.BuildRent].includes(loanType)) {
        if (
            property?.rental?.purchaseContract?.handleMode === 'providelater' &&
            property.rental?.purchasedLessThan2YearsAgo === true
        ) {
            formsRequired.push('Purchase Contract');
        }
        if (
            property?.rental?.capitalExpenditures?.handleMode === 'providelater' &&
            property.rental?.moreThan10kExpenditures === true
        ) {
            formsRequired.push('Capital Expenditures');
        }
    }

    if (formsRequired.length === 1) {
        return formsRequired[0];
    } else if (formsRequired.length === 2) {
        return formsRequired.join(' and ');
    } else if (formsRequired.length > 2) {
        const last = formsRequired.pop();
        return formsRequired.join(', ') + ' and ' + last;
    }

    return undefined;
};
